import React, { useState, useEffect, useCallback,useRef } from "react";
import { Button } from "react-bootstrap";
import { useLocation,useNavigate } from "react-router-dom"; 
import { ArrowLeftCircle } from "react-bootstrap-icons";
import AxiosInstance from "../AxiosInstance";
import ToastNotification from "../ToastNotification";
import EmployeeRemarksTable from "./EmployeeRemarksTable";
import EmployeeRemarksModal from "./EmployeeRemarksModal";
import Layout from "./Layout";

const EmployeeRemarks = () => {
  const location = useLocation();  // Use useLocation hook
  const userId = location.state?.userId || localStorage.getItem("userId"); 
  const navigate=useNavigate();
  const [remarks, setRemarks] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedRemark, setSelectedRemark] = useState(null);
  const [remarkTopics, setRemarkTopics] = useState([]);
   const toastRef = useRef(null);
  const [employeeDetails, setEmployeeDetails] = useState(null);

   useEffect(() => {
    const fetchEmployeeDetails = async () => {
      try {
        const res = await AxiosInstance.get(`/common/api/user-details/${userId}`);
        setEmployeeDetails(res.data);
      } catch (err) {
        toastRef.current?.showToast("Error fetching employee details:", "danger");
      }
    };
  
    if (userId) {
      fetchEmployeeDetails();
    }
  }, [userId]);
 const fetchRemarks = useCallback(async () => {
  try {
    const userId = location.state?.userId; 
    const res = await AxiosInstance.get(`/admin/get-user-remarks/${userId}`); 
    setRemarks(res.data);
  } catch (err) {
    if (err.response?.status === 404) {
      // User has no remarks yet — don't show toast
      console.log("No remarks found for this user.");
      setRemarks([]); // Still set empty array so UI works
    } else {
      // Real error — show toast
      toastRef.current?.showToast(
        "Error fetching remarks: " + (err.response?.data?.message || err.message),
        "danger"
      );
    }
  }
}, [location]);

  const fetchRemarkTopics = useCallback(async () => {
    try {
      const res = await AxiosInstance.get("/admin/get-remark-topics");
      setRemarkTopics(res.data);
    } catch (err) {
     toastRef.current?.showToast("Error fetching remark topics:", "danger");
    }
  }, []);

  useEffect(() => {
    fetchRemarks();
    fetchRemarkTopics();
  }, [fetchRemarks,fetchRemarkTopics]);
 
  const handleDelete = async (id) => {
    try {
      await AxiosInstance.delete(`/admin/delete-remark/${id}`); 
      toastRef.current.showToast("Remark deleted successfully!", "success");
      setRemarks((prevRemarks) => prevRemarks.filter((remark) => remark.id !== id));
    } catch (err) {
      toastRef.current.showToast("Failed to delete remark.", "danger");
    }
  };

  const handleEdit = (id) => {
    const remarkToEdit = remarks.find((remark) => remark.id === id);
    setSelectedRemark(remarkToEdit);
    setShowModal(true);
  };

  const handleAdd = () => {
    setSelectedRemark(null);
    setShowModal(true);
  };

  const handleSave = () => {
    fetchRemarks();  // Refresh the remarks list after add/edit
  }; 
    
  const formatValue = (value) => {
    return value ? value : "N/A";
  };
   
  const capitalizeWords = (str) => {
    return str
      .toLowerCase()
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };  

  return (
    <Layout heading="Remarks">
      {/* Align Back button and Add Remark button */}
      <div className="d-flex align-items-center justify-content-between mt-4 mb-3">
        <div className="d-flex align-items-center gap-3">
          <Button className="btn btn-secondary" onClick={() => navigate(-1)}>
            <ArrowLeftCircle />
          </Button>
          {employeeDetails && (
            <div>
              <h6 className="fw-bold mb-0">
                {capitalizeWords(`${formatValue(employeeDetails.first_name)} ${employeeDetails.middle_name ? formatValue(employeeDetails.middle_name) + ' ' : ''}${formatValue(employeeDetails.last_name)}`)}
              </h6>
              <small className="text-muted">
                {formatValue(employeeDetails.employee_code)}
              </small>
            </div>
          )}
        </div>
        <Button variant="primary" onClick={handleAdd}>
          <i className="bi bi-plus-lg me-1"></i> Remark
        </Button>
      </div>
  
      {/* Table Container */}
      <div className="container mt-4">
        <EmployeeRemarksTable
          remarks={remarks}
          handleDelete={handleDelete}
          handleEdit={handleEdit}
        />
      </div>
  
      {/* Modal for Add/Edit Remark */}
      <EmployeeRemarksModal
        show={showModal}
        onHide={() => setShowModal(false)}
        remarkTopics={remarkTopics}
        remarkData={selectedRemark}
        onSave={handleSave}
        userId={location.state?.userId} // Pass userId to modal if needed
      />
  
      <ToastNotification ref={toastRef} />
    </Layout>
  );
  
};

export default EmployeeRemarks;
